(() => {
  function initDescriptions(root = document) {
    root.querySelectorAll('[data-collection-description]:not([data-description-initialized])').forEach(description => {
      description.dataset.descriptionInitialized = 'true';
      const button = description.parentElement.querySelector('[data-collection-description-toggle]');
      if (!button) return;

      const lines = Number(description.dataset.previewLines);
      let previewHeight = 0;
      let fullHeight = 0;
      const updateHeight = () => {
        const style = getComputedStyle(description);
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.6;
        previewHeight = Math.ceil(lineHeight * lines);
        description.classList.add('is-ready');
        description.style.setProperty('--description-height', 'none');
        fullHeight = description.scrollHeight;
        const needsToggle = fullHeight > previewHeight + 2;
        button.hidden = !needsToggle;
        description.style.setProperty('--description-height', `${needsToggle && button.getAttribute('aria-expanded') === 'false' ? previewHeight : fullHeight}px`);
      };

      updateHeight();
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'false';
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'See less' : 'See more';
        description.style.setProperty('--description-height', `${expanded ? fullHeight : previewHeight}px`);
      });
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateHeight).observe(description.parentElement);
      }
      document.fonts?.ready.then(updateHeight);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDescriptions());
  } else {
    initDescriptions();
  }
  document.addEventListener('shopify:section:load', event => initDescriptions(event.target));
})();
